<template>
  <div class="ql-container ql-snow">
    <p class="legalContent ql-editor" v-html="pageInfo"></p>
  </div>
</template>
<script>
import {apiPageInfo} from "@/request/API";

export default {
  name: '',
  props: {
    key1: String,
  },
  components: {

  },
  data () {
    return {
      pageInfo:''
    }
  },
  methods: {
    getPageInfo(){
      apiPageInfo({
        id:this.key1
      }).then(res=>{
        this.pageInfo = res.data.content
      })
    }
  },
  mounted () {
    this.getPageInfo()
  },
  watch: {
    key1(val, oldVal){//普通的watch监听
      this.key1 = val
      this.getPageInfo()
    },
  },
  computed: {

  }
}
</script>

<style  scoped>
.ql-container{
  border: none !important;
  padding: 36px 48px 64px;
  background: var(--bg-card, #FFFFFF);
  box-sizing: border-box;
}
.legalContent{
  padding: 0;
  /*width: 871px;*/
  overflow: auto;
  margin: 0;
  font-size: 15px;
  line-height: 1.9;
  color: var(--text-secondary, #5A5F6B);
  word-break: break-word;
}
.legalContent >>> h1,
.legalContent >>> h2,
.legalContent >>> h3{
  position: relative;
  margin: 28px 0 16px;
  padding-bottom: 7px;
  color: var(--text-main, #1A1D24);
  font-weight: 700;
  line-height: 1.45;
}
.legalContent >>> h1:first-child,
.legalContent >>> h2:first-child,
.legalContent >>> h3:first-child{
  margin-top: 0;
}
.legalContent >>> h2{
  font-size: 22px;
}
.legalContent >>> h3{
  font-size: 18px;
}
.legalContent >>> h1::after,
.legalContent >>> h2::after,
.legalContent >>> h3::after{
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 34px;
  height: 3px;
  background: var(--primary, #FF5A1F);
}
.legalContent >>> img{
  max-width: 100% !important;
  height: auto !important;
  object-fit: contain !important;
  border-radius: 4px;
}
</style>
